import React from 'react'
import styles from './project-edit-warn-modal.module.scss'
import Button from '@material-ui/core/Button'
import { TranslationDictionary } from '@plandi/common'

type ProjectEditWarnModalProps = {
  onLeave: () => void
  onCancel: () => void
  translate?: TranslationDictionary['data']
}

export const ProjectEditWarnModal: React.FC<ProjectEditWarnModalProps> = ({
  onLeave,
  onCancel,
  translate
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.modal}>
        <div className={styles.warnTextBlock}>
          <p className={styles.warnText}>{translate?.['lost-entered-data']}</p>
          <p className={styles.warnQuestionText}>
            {translate?.['sure-to-continue']}
          </p>
        </div>
        <div className={styles.buttons}>
          <Button variant="contained" color="secondary" onClick={onLeave}>
            {translate?.yes}
          </Button>
          <Button variant="contained" color="primary" onClick={onCancel}>
            {translate?.no}
          </Button>
        </div>
      </div>
    </div>
  )
}
